import { render, staticRenderFns } from "./banjiupdate.vue?vue&type=template&id=4b4350b6&scoped=true&"
import script from "./banjiupdate.js?vue&type=script&lang=js&"
export * from "./banjiupdate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4350b6",
  null
  
)

export default component.exports